import { AbstractStorageProvider } from "./AbstractStorageProvider.js";
class FallbackStorageProvider extends AbstractStorageProvider {
  fallbackStore;
  constructor(store, fallbackStore) {
    super(store);
    this.fallbackStore = fallbackStore;
  }
  async get(key) {
    return this.store.get(key) ?? this.fallbackStore.get(key);
  }
  async set(key, value) {
    this.store.set(key, value);
    this.fallbackStore.set(key, value);
  }
  async has(key) {
    return this.store.has(key) || this.fallbackStore.has(key);
  }
  async delete(key) {
    this.store.delete(key);
    this.fallbackStore.delete(key);
  }
}
export {
  FallbackStorageProvider
};
//# sourceMappingURL=FallbackStorageProvider.js.map
